import { createSelector } from '@reduxjs/toolkit';
import { getOrganizationId, getUser } from 'src/store/selectors';
import { orderBy } from 'lodash';
import type { User } from 'src/store/types';

/**
 * Returns a list of organizations previously loaded by the current user, the most recent first.
 * Based on timestamp saved in user object by saveOrganizationLoadTime() in d-app, called by d-account
 */
export const lastOrganizationsLoadedByUser = createSelector(
  getUser,
  getOrganizationId,
  (user: User, organizationId: number): { id: number; name: string }[] => {
    const organizations: { id: number; timestamp: number }[] = [];
    for (const key of Object.keys(user)) {
      if (key.includes('_')) {
        const property = key.split('_')[1];
        if (property === 'lastLoaded') {
          const id = Number(key.split('_')[0]);
          if (id !== organizationId && typeof user[key] === 'number') {
            organizations.push({ id, timestamp: user[key] });
          }
        }
      }
    }
    const sorted = orderBy(organizations, ['timestamp'], ['desc']);
    return sorted
      .map((s) => {
        const org = user.organizations.find((o) => {
          return o.id === s.id;
        });
        return { id: s.id, name: org?.name ?? '' };
      })
      .filter((o) => {
        return o.name !== '';
      });
  },
);
